import React, { useEffect, useState } from "react";
import {
    Badge,
    Box,
    Flex,
    HStack,
    Spinner,
    Text,
    VStack,
    Avatar,
    Divider,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import StatusBadge, {
    getStatusVariant,
} from "components/Badges/StatusBadge";

import ReusableDrawer from "components/Drawers/ReusableDrawer";

import ViewDriver from "views/Dashboard/DriverManagement/components/ViewDriver";

import { fetchReferredDriversAction } from "state/actions/referredDriverActions";

const statusColor = {
    Approved: "green",
    Pending: "yellow",
    Rejected: "red",
    Suspended: "orange",
    Deactivated: "gray",
};

const ReferredDriversDrawer = ({
    isOpen,
    onClose,
    referralCode,
}) => {
    const dispatch = useDispatch();

    const {
        referredDrivers,
        loading,
    } = useSelector(
        (state) => state.referredDrivers
    );
    const getProfileImage = (user) => {
    const doc = user?.documents?.find(
        (d) => d.document_type === "Profile Image"
    );

    if (!doc) return null;

    const API_URL =
        process.env.REACT_APP_API_BASE_URL.replace(/\/$/, "");

    return `${API_URL}/${doc.file_path.replace(/^\//, "")}`;
};

const [selectedDriver, setSelectedDriver] =
    useState(null);

const [
    isViewDriverOpen,
    setViewDriverOpen,
] = useState(false);

const handleViewDriver = (
    driver
) => {
    setSelectedDriver({
        driver,
    });

    setViewDriverOpen(true);
};
    useEffect(() => {
        if (
            isOpen &&
            referralCode
        ) {
            dispatch(
                fetchReferredDriversAction(
                    referralCode
                )
            );
        }
    }, [
        dispatch,
        isOpen,
        referralCode,
    ]);

    return (
        <>
        <ReusableDrawer
            isOpen={isOpen}
            onClose={onClose}
            size="md"
            headerContent={
                <Text
                    fontSize="lg"
                    fontWeight="700"
                >
                    Partner Referred Drivers
                </Text>
            }
            bodyContent={
                loading ? (
                    <Flex
                        justify="center"
                        py={10}
                    >
                        <Spinner
                            size="lg"
                            color="#071D54"
                        />
                    </Flex>
                ) : (
                    <VStack
                        align="stretch"
                        spacing={0}
                    >
                        {referredDrivers.length ===
                        0 ? (
                            <Text
                                textAlign="center"
                                py={10}
                                color="gray.500"
                            >
                                No referred
                                drivers found.
                            </Text>
                        ) : (
                            referredDrivers.map(
                                (
                                    driver
                                ) => (
                                    <Box
                                        key={driver.driver_id}
                                        cursor="pointer"
                                        _hover={{
                                            bg: "gray.50",
                                        }}
                                        transition="0.2s"
                                        onClick={() =>
                                            handleViewDriver(driver)
                                        }
                                    >
                                        <HStack
                                            py={4}
                                            justify="space-between"
                                        >
                                            <HStack
                                                spacing={
                                                    4
                                                }
                                            >
                                              <Avatar
                                                    name={driver.user?.username}
                                                     src={getProfileImage(driver.user)}
                                                     color={"#071D54"}
                                                />

                                                <Box>
                                                    <Text
                                                        fontWeight="600"
                                                    >
                                                        {`${driver.user?.first_name || ""} ${
                                                            driver
                                                                .user
                                                                ?.last_name ||
                                                            ""
                                                        }`.trim() ||
                                                            driver
                                                                .user
                                                                ?.username}
                                                    </Text>

                                                    <Text
                                                        fontSize="sm"
                                                        color="gray.500"
                                                    >
                                                        {
                                                            driver
                                                                .user
                                                                ?.phone_number
                                                        }
                                                    </Text>
                                                </Box>
                                            </HStack>
                                        <StatusBadge
                                            label={driver.status}
                                            variant={getStatusVariant(
                                                driver.status
                                            )}
                                        />
                                        </HStack>

                                        <Divider />
                                    </Box>
                                )
                            )
                        )}
                    </VStack>
                )
            }
        />
        <ReusableDrawer
    isOpen={isViewDriverOpen}
    onClose={() =>
        setViewDriverOpen(false)
    }
    headerContent={
        <h2>Driver</h2>
    }
    bodyContent={
        selectedDriver && (
            <ViewDriver
                driver={selectedDriver}
                onClose={() =>
                    setViewDriverOpen(false)
                }
            />
        )
    }
/>
</>
    );
};

export default ReferredDriversDrawer;